import { pkg } from './package-root.ts';

export const API_CLIENT = 'sl-cli';

export function userAgent(): string {
  return `${API_CLIENT}/${pkg.version} (node/${process.versions.node})`;
}

export function baseRequestHeaders(): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    'X-API-Client': API_CLIENT,
    'User-Agent': userAgent(),
  };
}
